export default __webpack_public_path__ + "57c0f78dc770f2745b71504c41a63c79.png";